import React, { Component } from 'react';
import styled from 'styled-components';
import ErrorBoundary from '../../ErrorBoundary';

const Wrapper = styled.div`
  z-index: 1002;
  .uk-icon-button,
  .uk-icon-button:active,
  .uk-active > .uk-icon-button {
    opacity: 0.9;
    margin: 15px;
    width: 8vw;
    min-width: 45px;
    height: 8vw;
    min-height: 45px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }
  .uk-icon-button.uk-offcanvas-close {
    z-index: 1002;
  }
  #offcanvas-overlay button{
    z-index: 1004;
  }
`;

export default class NavbarMobile extends Component {
  static propTypes = {};

  render() {
    return (
      <ErrorBoundary>
        <Wrapper className="nav-navbar-mobile uk-hidden@m" data-uk-sticky>
          <button
            className="uk-icon-button open-menu"
            type="button"
            aria-label="Menu"
            data-uk-toggle="target: #offcanvas-overlay; mode: click"
          >
            <span data-uk-icon="icon: menu"></span>
          </button>

          <div id="offcanvas-overlay" data-uk-offcanvas="flip: true; overlay: true">
            <button
              className="uk-icon-button uk-offcanvas-close"
              type="button"
              aria-label="Close"
              data-uk-close
            ></button>
            <div className="uk-offcanvas-bar uk-flex uk-flex-column" aria-label="Main Navigation">
              <ul className="uk-nav uk-nav-primary uk-nav-center uk-margin-auto-vertical">
                <li className="uk-active">
                  <a href="#home" aria-current="page">
                    Home
                  </a>
                </li>
                <li>
                  <a href="#framing" aria-current="page">
                    Custom Framing
                  </a>
                </li>
                <li>
                  <a href="#gifts" aria-current="page">
                    Gifts & More
                  </a>
                </li>
                <li>
                  <a href="#holidays" aria-current="page">
                    Holidays
                  </a>
                </li>
                <li>
                  <a href="#pond" aria-current="page">
                    The Pond
                  </a>
                </li>
                <li>
                  <a href="#contact" aria-current="page">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </Wrapper>
      </ErrorBoundary>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/nav/NavbarMobile.js